import { render } from "./Departments.vue?vue&type=template&id=5ba9cf80"
import script from "./Departments.vue?vue&type=script&lang=js"
export * from "./Departments.vue?vue&type=script&lang=js"
script.render = render

export default script